import React, { useState, useEffect } from 'react';
import './WalletSelector.css';

const WalletSelector = ({ onSelect, onClose }) => {
  const [hasPhantom, setHasPhantom] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const detect = async () => {
      await new Promise(r => setTimeout(r, 400));
      const detected = !!(window.phantom?.ethereum || window.ethereum?.isPhantom);
      setHasPhantom(detected);
      setChecking(false);
    };
    detect();
  }, []);

  const handleConnect = () => {
    if (!hasPhantom) {
      window.open('https://phantom.app/', '_blank');
      return;
    }
    onSelect('phantom');
  };

  return (
    <div className="wallet-selector-overlay" onClick={onClose}>
      <div className="wallet-selector-modal" onClick={e => e.stopPropagation()}>
        <button className="wallet-selector-close" onClick={onClose}>×</button>
        <h2 className="wallet-selector-title">Connect Wallet</h2>
        <p className="wallet-selector-subtitle">Phantom wallet required</p>

        {checking ? (
          <div className="wallet-checking">
            <div className="wallet-spinner"></div>
            <p>Detecting Phantom...</p>
          </div>
        ) : (
          <div className="wallet-options">
            <button
              className={`wallet-option ${!hasPhantom ? 'wallet-disabled' : ''}`}
              onClick={handleConnect}
            >
              <div className="wallet-icon">👻</div>
              <div className="wallet-info">
                <h3>Phantom</h3>
                <p>{hasPhantom ? 'Detected — click to connect' : 'Not installed'}</p>
              </div>
              {!hasPhantom && <span className="wallet-badge">Install</span>}
            </button>
          </div>
        )}

        <div className="wallet-selector-footer">
          <p className="wallet-help-text">
            {hasPhantom ? 'Click to connect your Phantom wallet' : 'Install Phantom from phantom.app'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalletSelector;
